import React from "react";
import { Row, Col } from "react-bootstrap";
import { Icon } from "semantic-ui-react";
import moment from "moment";
import ReactGA from "react-ga";

class OSAgencyCard extends React.Component {
  goToAgency = (url) => {
    let outgoingTrip = JSON.parse(localStorage.getItem("outgoingTrip"));
    let incomingTrip = JSON.parse(localStorage.getItem("incomingTrip"));

    ReactGA.event({
      category: "Agencies",
      action: "goAgencyUrl",
      label: `goAgencyUrl#${moment(this.props.sdate).format(
        "YYYYMMDD"
      )}#${moment(outgoingTrip.departureDateTime).format("hhmm")}#${
        this.props.agencyId
      }#${
        this.props.webSiteUrl
      }#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`,
    });
    if (incomingTrip) {
      ReactGA.event({
        category: "Agencies",
        action: "postBookingAgent",
        label: `postBookingAgent#${moment(this.props.sdate).format(
          "YYYYMMDD"
        )}#${moment(outgoingTrip.departureDateTime).format("hhmm")}#${
          this.props.agencyId
        }#${outgoingTrip.company.id}#${moment(this.props.sdate).format(
          "YYYYMMDD"
        )}#${moment(this.props.edate).format("YYYYMMDD")}#${
          outgoingTrip.vessel.id
        }#${moment(incomingTrip.departureDateTime).format(
          "YYYYMMDD"
        )}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`,
      });
    } else {
      ReactGA.event({
        category: "Agencies",
        action: "postBookingAgent",
        label: `postBookingAgent#${moment(this.props.sdate).format(
          "YYYYMMDD"
        )}#${moment(outgoingTrip.departureDateTime).format("hhmm")}#${
          this.props.agencyId
        }#${outgoingTrip.company.id}#${moment(this.props.sdate).format(
          "YYYYMMDD"
        )}#${moment(this.props.edate).format("YYYYMMDD")}#${
          outgoingTrip.vessel.id
        }#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`,
      });
    }

    window.open(url, '_blank').focus();
  };

  render() {
    let refactoredPhone = this.props.tel.replace(new RegExp(",", "g"), ", ");

    return (
      <Row className="TableRow" key={this.props.key}>
        <Col
          lg={10}
          md={10}
          sm={10}
          xs={10}
          style={{ borderBottom: "0px solid transparent", paddingRight: "0px" }}
        >
          <Col lg={5} md={5} sm={5} xs={12} style={{ padding: "0px" }}>
            <div className="portName">
              {this.props.name} / {this.props.address}{" "}
            </div>
          </Col>
          <Col className="removePaddingsOnXS" lg={4} md={4} sm={4} xs={12}>
            <div className="portName">{refactoredPhone} </div>
          </Col>
          <Col lg={3} md={3} sm={3} xs={12} style={{ padding: "0px" }}>
            <div className="portName">{this.props.fax} </div>
          </Col>
        </Col>
        <Col lg={2} md={2} sm={2} xs={2} style={{ padding: "0px" }}>
          <Icon
            onClick={() => this.goToAgency(this.props.url)}
            style={{ cursor: "pointer" }}
            name="ticket"
            size="big"
          />
        </Col>
      </Row>
    );
  }
}

export default OSAgencyCard;



// WEBPACK FOOTER //
// ./src/components/OSAgencyCard/OSAgencyCard.js